import { render, staticRenderFns } from "./son-info.vue?vue&type=template&id=afe9f922&"
import script from "./son-info.vue?vue&type=script&lang=ts&"
export * from "./son-info.vue?vue&type=script&lang=ts&"
import style0 from "./son-info.vue?vue&type=style&index=0&id=afe9f922&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports